import { PromptOptions } from "./cer-ui-prompt.service";

const HeaderCerErrorCodeExtended: string = "x-cer-error-code-extended";
const HeaderCerAppVersion: string = "X-Cer-App-Version";
const HeaderCerErrorCodeExtendedClientVersionMismatch = "client-version-mismatch";

export class CerAppDialogErrorApi {

  public static async Setup(error: any, operation: string = null, status: number = null): Promise<PromptOptions> {
    if (typeof error === 'string' || error instanceof String) {
        var err = JSON.parse(<string> error);
        if (err != null) {
          return await CerAppDialogErrorApi.Setup(err, operation, status);
        }
    }

    if (error instanceof Response) {
      error = await CerAppDialogErrorApi.getResponseError(error as Response);
    }

    if (error?.status) {
      if (Number.isInteger(error.status)) {
        status = error.status;
      }
      else if (typeof error.status == "string") {
        status = parseInt(error.status);
      }
    }
    if (error.message == "Cannot read properties of undefined (reading 'records')") {
      return { type: 'silent', defaultAction: 'ok' } as PromptOptions;
    }
    if (error != null && Array.isArray(error) && error.length > 0) {
      var errorSub = error[0];
      return await CerAppDialogErrorApi.Setup(errorSub.error ?? errorSub, operation, status);
    }
    if (error?.error != null) {
      if (Array.isArray(error.error) && error.error.length > 0) {
        return await CerAppDialogErrorApi.Setup(error.error[0], operation, status);
      }
      if (typeof error.error === 'string' || error.error instanceof String) {

        var err = JSON.parse(error.error);
        if (err != null) {
          return await CerAppDialogErrorApi.Setup(err, operation, status);
        }
      }
      return await CerAppDialogErrorApi.Setup(error.error, operation, status);
    }

    var options: PromptOptions = CerAppDialogErrorApi.promptOptions(error);
    switch (status) {
      case 200:
        // WebApi validation errors - returned with status 200 (because of SF DM limit) (204? future)
        break;
      case 404:
        options.title = options.title ?? "Findes ikke";
        options.content = operation?.length > 0 ? `${operation}: Ressourcen findes ikke.` : "Ressourcen findes ikke.";
        break;
      case 401:
        options.title = options.title ?? "Ingen adgang";
        options.content = "Log venligst ind igen.";
        options.defaultAction = 'reload';
        break;
      case 422:
        options.type = 'confirm';
        options.title = options.title ?? "Valideringsfejl";
        //options.actions = ['retry', 'cancel'];
        options.defaultAction = 'retry';
        break;
    }
    options.type ??= 'error';
    options.title ??= "API fejl";
    options.content ??= "Der er opstået en fejl.";
    return options as PromptOptions;
  }

  static async getResponseError(response: Response): Promise<any> {
    var body = (response as any)?.body;
    if (body != null && body instanceof ReadableStream) {
      var reader = body.getReader();
      var result = await reader.read();
      if (result.done) {
        return null;
      }
      var value = result.value;
      if (value != null && value.length > 0) {
        const s: string = new TextDecoder().decode(value);
        if (s?.length > 0) {
          const res = JSON.parse(s);
          if (res.errors != null) {
            res.headers = response.headers; 
            return res;
          }
        }
      }
    }
    return response;
  }

  private static promptOptions(error: any): PromptOptions {
    if (!error) {
      return {};
    }

    // Response prompt 
    var prompt: Partial<PromptOptions> = {};

    // Bearer token errors
    if (error.headers) {

      var wwwAuthenticate: string = error.headers['www-authenticate'];
      if (wwwAuthenticate?.startsWith('Bearer error="invalid_token"')) {
        console.error(wwwAuthenticate);
        return {
          type: 'error',
          title: 'Du er ikke logget ind.',
          message: 'Log venligst ind igen.'
        } as PromptOptions;
      }

      if (error.headers[HeaderCerErrorCodeExtended]     == HeaderCerErrorCodeExtendedClientVersionMismatch || 
          error.headers.get(HeaderCerErrorCodeExtended) == HeaderCerErrorCodeExtendedClientVersionMismatch) {
        prompt.defaultAction = 'clientVersionMismatch';
        prompt.errorAppVersion = error.headers[HeaderCerAppVersion] ?? error.headers.get(HeaderCerAppVersion);
      }
    }

    if (error.response && (!error.headers || error.headers['content-type'].includes('json'))) {
      prompt = CerAppDialogErrorApi.DialogSetupFromResponse(error);
      if (prompt.content) {
        return prompt;
      }
    }

    if (error.title) {
      prompt.title = error.title;
      prompt.content = CerAppDialogErrorApi.ObjectAsHtml(error.errors);
    }
    else if (error.message) {
      prompt.content = error.message;
    }

    if (error.error && error.error instanceof XMLHttpRequest) {
      prompt.content = error.error;
    }

    return prompt;
  }

  static DialogSetupFromResponse(error: any): PromptOptions {
    var response = error.response;
    var options: Partial<PromptOptions> = {};
    if (typeof response === 'string' || response instanceof String) {
      response = JSON.parse(<string>response);
    }
    if (response) {
      if (response.title) {
        options.title = response.title;
      }
      if (response.detail) {
        options.content = CerAppDialogErrorApi.ObjectAsHtml(response.detail);
      }
      else if (response.errors) {
        options.content = CerAppDialogErrorApi.ObjectAsHtml(response.errors);
      }
      else if (typeof response === 'string' || response instanceof String) {
        options.content = response as string;
      }
    }
    return options;
  }

  private static ObjectAsHtml(o: any): string {
    var msg: string = '';
    if (typeof (o) == 'string') {
      return '<p>' + o + '</p>';
    }
    for (var prop in o) {
      var value = o[prop];

      if (!Array.isArray(value)) {
        if (value?.length > 0) {
          msg += '<p>' + (prop.length > 0 ? prop + ": " : "") + value + '</p>';
        }
      }
      else {
        var hasProp = (prop?.length > 0);
        if (hasProp) {
          msg += '<p>' + prop + ':</p>';
          msg += '<ul>'
          for (var i = 0; i < value.length; i++) {
            msg += '<li>' + value[i] + '</li>';
          }
          msg += '</ul>';
        }
        else {
          for (var i = 0; i < value.length; i++) {
            msg += '<p>' + value[i] + '</p>';
          }
        }
      }
    }
    return msg;
  }
}
